<template>
    <Spinner
        class="mt-32"
        appearance="dots"
        size="xl"
        color="black"
        v-bind="$props"
    ></Spinner>
</template>

<script>
export default {
    name: 'TabsPanelSpinner',
};
</script>
